import { observable, action, computed, makeObservable } from "mobx";
import PopupElement from "../models/PopupElement";

class WebPush {
  constructor(rootStore) {
    makeObservable(this, {
      isShowInvitation: observable,
      CanShowInvitation: computed,
      showWebPushPopup: action,
      hideInvtation: action,
      acceptInvitation: action,
    });

    this.rootStore = rootStore;
    this.webpushPopup = new PopupElement({
      name: "webpushPopup",
      eventType: "internal",
      priority: "important",
      position: "topLeft",
      openCallback: this.showInvitation,
      custom: true,
    });

    this.isPushApiEnabled =
      "PushManager" in window ||
      ("safari" in window && "pushNotification" in window.safari);
  }

  isShowInvitation = false;

  get CanShowInvitation() {
    if (!("Notification" in window)) return false;

    const result =
      (this.rootStore.clientStorage.isUserChanged ||
        this.rootStore.clientStorage.needToShowInvite) &&
      !this.NotificationIsDenied() &&
      this.rootStore.clientStorage.itsTimeForInvite &&
      this.rootStore.feedSettings.ntfIsActivated &&
      this.isPushApiEnabled &&
      window.innerWidth > 600;

    if (result && this.rootStore.clientStorage.needToShowInvite) {
      this.rootStore.clientStorage.setNeedToShowInvite(false);
    }

    return result;
  }

  showWebPushPopup = (forceShow) => {
    if (this.CanShowInvitation || forceShow) {
      this.rootStore.popupController.addPopupToQueue(this.webpushPopup);
    }
  };

  showInvitation = () => {
    this.isShowInvitation = true;
  };

  hideInvtation = () => {
    this.isShowInvitation = false;
    this.rootStore.clientStorage.setInviteTimestamp();
    this.rootStore.popupController.handlePopupClose(this.webpushPopup);
  };

  acceptInvitation = () => {
    this.isShowInvitation = false;
    this.rootStore.clientStorage.setInviteTimestamp();
    window.open(this.rootStore.feedSettings.webPushFrame, "_blank");
  };

  NotificationIsDenied = () => Notification.permission === "denied";
}

export default WebPush;
